<script>
import EdRequest from '../../../root/EdRequest.vue'

/** Decodifica base64 URL‑safe (state) */
function b64UrlDecode (str) {
  str = str.replace(/-/g, '+').replace(/_/g, '/')
  while (str.length % 4) str += '='
  return atob(str)
}

export default {
  name: 'OAuth2Callback',
  mixins: [EdRequest],

  data () {
    return { loading: true, error: null, success: false }
  },

  methods: {
    async processCallback () {
      try {
        /* 1. Recupera code e state da URL */
        const { code, state } = this.$route.query
        if (!code)  throw new Error('Código de autorização não encontrado na URL.')
        if (!state) throw new Error('Parâmetro "state" ausente na URL.')

        /* (opcional) sanity check do state */
        try { JSON.parse(b64UrlDecode(state)) } catch (_) {}

        /* 2. Troca code → tokens */
        const cbResp = await this.get('oauth2/callback', { code, state }, null, true)

        const { success, conta_email_id, oauth_access_token, error } = cbResp
        if (!success) throw new Error(error || 'Erro no callback OAuth2.')

        /* 3. Salva tokens */
        await this.post(
          `conta-email/${conta_email_id}/oauth2/salvar`,
          { oauth_access_token },
          null,
          true
        )

        /* 4. Redireciona */
        this.success = true
        setTimeout(() => this.$router.push('/conta-email'), 3000)

      } catch (err) {
        console.error('OAuth2 callback erro:', err)
        this.error =
          (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'Erro ao processar o callback.'
      } finally {
        this.loading = false
      }
    }
  },

  mounted () {
    this.processCallback()
  }
}
</script>



// WEBPACK FOOTER //
// oAuth2Callback.vue?0d022b6d